import { colors, createStyles } from "@material-ui/core";
export var styles = function (_a) {
    var spacing = _a.spacing;
    return createStyles({
        root: {
            fontSmoothing: "antialiased",
            fontWeight: 700,
            fontSize: 13,
            lineHeight: "18px",
            textAlign: "center",
            padding: spacing(2.5),
            paddingLeft: spacing(3),
            paddingRight: spacing(3),
            borderRadius: 15,
            transition: "background-color .25s",
            marginTop: spacing(2),
            marginBottom: spacing(2)
        },
        success: {
            backgroundColor: "#EEF2FF",
            color: "#1B0406"
        },
        error: {
            backgroundColor: "#FFF0F0",
            color: colors.red[700]
        }
    });
};
